import { render, staticRenderFns } from "./SelectSection.vue?vue&type=template&id=abc96130&scoped=true&"
import script from "./SelectSection.vue?vue&type=script&lang=ts&"
export * from "./SelectSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc96130",
  null
  
)

export default component.exports